/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Fallback_Project_Import_ToastInputs */



/**
* | output |
* | --- |
* | "Using project file import method" |
*
* @param {Explorer_Info_Fallback_Project_Import_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_fallback_project_import_toast = /** @type {((inputs?: Explorer_Info_Fallback_Project_Import_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Fallback_Project_Import_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Utilisation de la methode d'import du fichier projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verwendung der Projektdatei-Importmethode")
	if (locale === "it") return /** @type {LocalizedString} */ ("Utilizzo del metodo di importazione del file di progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Использование метода импорта файлов проекта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Uso del método de importación de archivos de proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("使用项目文件导入方法")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトファイルのインポート方法を使用する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट फ़ाइल आयात विधि का उपयोग करना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Utilizando o método de importação de arquivo de projeto")
	return /** @type {LocalizedString} */ ("Using project file import method")
});